import {createStore, applyMiddleware, AnyAction, Store} from 'redux';
import { Action, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware, {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import {createBrowserHistory, History} from 'history';

import {appReducer} from './app/app.reducer';
import {authReducer} from './auth/auth.reducer';
import {accountReducer} from './account/account.reducer';

//combine reducers
const createRootReducer = (history: History) => combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    app: appReducer,
    account: accountReducer,
})

//add browser history here at later time
export const history = createBrowserHistory({basename: '/authenticate'});
const rootReducer = createRootReducer(history);

//function creating store
export default function getStore(preloadedState?: any) {
    const middlewares = [thunkMiddleware, routerMiddleware(history)];
    const middlewareEnhancer = applyMiddleware(...middlewares);
    const enhancers: any = [middlewareEnhancer];
    const composedEnhancers = composeWithDevTools(...enhancers);
    return createStore(rootReducer, preloadedState, composedEnhancers);
};

//export types
export type RootState = ReturnType<typeof rootReducer>

export type TAppState = ReturnType<typeof rootReducer>;
export type TDispatch = ThunkDispatch<TAppState, void, AnyAction>;
export type TStore = Store<TAppState, AnyAction> & { dispatch: TDispatch };
export type TGetState = () => TAppState;

export type Effect<ReturnType = void> = ThunkAction<ReturnType,
  RootState,
  unknown,
  Action<string>>
